const TreeNode = require('../TreeNode');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');
const AICalc = require('../AICalc');
const Q_has_option = require('./Q_has_option');

const Q_which_summon = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  node.FAERIE = 0;
  node.DWARF = 1;
  node.ELF = 2;
  node.NO_SUMMON = 3;

  node.summonFaerie = BattleCalc.getEquippedAbility(actor, 'summon_faerie');
  node.summonDwarf = BattleCalc.getEquippedAbility(actor, 'summon_dwarf');
  node.summonElf = BattleCalc.getEquippedAbility(actor, 'summon_elf');

  if (node.summonFaerie) {
    node.branches[node.FAERIE] = new UseAbility(actor, 'summon_faerie');
  }
  if (node.summonDwarf) {
    node.branches[node.DWARF] = new UseAbility(actor, 'summon_dwarf');
  }
  if (node.summonElf) {
    node.branches[node.ELF] = new UseAbility(actor, 'summon_elf');
  }

  node.branches[node.NO_SUMMON] = new Q_has_option(actor, battleState);

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.summonFaerie = null;
    node.summonDwarf = null;
    node.summonElf = null;
    originalDispose.call(node);
  };

  node.getNumOfOwnedSummonedUnits = function () {
    var faeries = 0;
    var dwarves = 0;
    var elves = 0;
    const allies = BattleCalc.getAlliesOfUnit(
      this.actor,
      this.battleState.allUnits,
      false
    ).filter((unit) => unit.ownerId === actor.uid);

    for (var i = 0; i < allies.length; ++i) {
      var unit = allies[i];
      if (unit.handle === 'faerie') {
        ++faeries;
      } else if (unit.handle === 'dwarf') {
        ++dwarves;
      } else if (unit.handle === 'elf') {
        ++elves;
      }
    }

    return {
      faeries,
      dwarves,
      elves,
    };
  };

  node.query = function () {
    const num = this.getNumOfOwnedSummonedUnits();

    if (
      this.summonFaerie &&
      (num.faeries <= num.dwarves || !this.summonDwarf) &&
      (num.faeries <= num.elves || !this.summonElf) &&
      num.faeries <
        BattleCalc.getMaxNumSummons({
          ability_handle: 'summon_faerie',
          caster_build: actor,
        })
    ) {
      return this.branches[this.FAERIE].query(
        AICalc.getBestSummonTile(actor, battleState)
      );
    } else if (
      this.summonDwarf &&
      (num.dwarves <= num.faeries || !this.summonFaerie) &&
      (num.dwarves <= num.elves || !this.summonElf) &&
      num.dwarves <
        BattleCalc.getMaxNumSummons({
          ability_handle: 'summon_dwarf',
          caster_build: actor,
        })
    ) {
      // summon dwarves between caster & the closest enemy
      const nearest_enemy = battleState.getNearestEnemyOf(actor);
      const candidate_tiles = [];
      for (
        let dist = 1;
        dist <= BattleCalc.boardDistance(actor, nearest_enemy);
        ++dist
      ) {
        for (const tile of Object.values(battleState.allTiles)) {
          if (
            !tile.occupied &&
            BattleCalc.boardDistance(nearest_enemy, tile) === dist &&
            BattleCalc.boardDistance(actor, tile) <=
              node.summonDwarf.range.max &&
            BattleCalc.pieceIsBetweenPair(tile, [actor, nearest_enemy])
          ) {
            candidate_tiles.push(tile);
          }
        }
        if (candidate_tiles.length) {
          break;
        }
      }

      return this.branches[this.DWARF].query(
        candidate_tiles.length
          ? candidate_tiles[Math.floor(Math.random() * candidate_tiles.length)]
          : AICalc.getBestSummonTile(actor, battleState)
      );
    } else if (
      this.summonElf &&
      num.elves <
        BattleCalc.getMaxNumSummons({
          ability_handle: 'summon_elf',
          caster_build: actor,
        })
    ) {
      return this.branches[this.ELF].query(
        AICalc.getBestSummonTile(actor, battleState)
      );
    } else {
      return node.branches[node.NO_SUMMON].query();
    }
  };

  return node;
};
module.exports = Q_which_summon;
